// @ts-nocheck
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { format, parseISO } from "date-fns";

import { ETAPAS_ANALISE } from "../../../helpers/process.helper";
import { CardPercent, CardStats, LinePercent } from "../styles";
import DocumentoAnalise from "./DocumentoAnalise";
import LaudoAnalise from "./LaudoAnalise";
import { Intro, Prazo, Trava } from "./styles";

// "2026-10-29" -> "29/10/2026" sem converter fuso.
const dataLegivel = (iso) => {
  if (!iso) return null;
  const [ano, mes, dia] = String(iso).slice(0, 10).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : null;
};

/**
 * Plano Análise: card das etapas "Envie seus documentos" (upload por
 * documento, apostila, progresso) e "Em análise" (prazo do laudo, lista
 * travada). Laudo e continuação chegam nas fases 3 e 4.
 */
export default function CardAnalise({ data, onProcessoAtualizado, controllerModal, FMDModal }) {
  const etapa = data?.step?.name;
  const analise = data?.analise || {};
  const uploadAberto = !!analise.upload_aberto && etapa === ETAPAS_ANALISE.documentos;
  const total = analise.total_documentos || 0;
  const enviados = analise.documentos_enviados || 0;
  const percentual = total > 0 ? Math.round((enviados / total) * 100) : 0;
  const prazo = dataLegivel(analise.prazo_laudo);

  // Procuração nunca aparece neste plano (a api já tira da lista; aqui é
  // só uma segunda trava para listas antigas).
  const documentos = (data?.service_documents || []).filter(
    (doc) => !/procura[çc][ãa]o/i.test(doc?.name || "") && doc?.status !== "NOT_REQUIRED"
  );

  if (etapa === ETAPAS_ANALISE.laudo || etapa === ETAPAS_ANALISE.aguardandoContinuacao) {
    return (
      <>
        <LaudoAnalise processo={data} onProcessoAtualizado={onProcessoAtualizado} />
        {documentos.map((doc) => (
          <DocumentoAnalise
            key={doc.document_id || doc.reference_id || doc.name}
            processo={data}
            documento={doc}
            uploadAberto={false}
            controllerModal={controllerModal}
            FMDModal={FMDModal}
          />
        ))}
      </>
    );
  }

  return (
    <>
      <CardStats>
        <p>{uploadAberto ? "documentos enviados" : "análise em andamento"}</p>
        <CardPercent color="var(--principal-50)">
          <span className="bar">
            <LinePercent size={percentual} color="var(--principal-50)" />
          </span>
          <span className="percent" data-testid="analise-progresso">
            {enviados} de {total}
          </span>
        </CardPercent>

        {uploadAberto ? (
          <Intro>
            <strong>Envie a foto ou o PDF de cada documento</strong>
            <p>
              Emita os documentos nas especificações indicadas e envie aqui, pelo celular ou pelo computador.
              Não precisa mandar nada pelos Correios nesta etapa.
            </p>
            <p>
              <b>Guarde os originais em papel:</b> eles serão necessários na continuação do processo.
            </p>
            <p>
              Apostilar agora é opcional e adianta a próxima fase. Marque "já está apostilado" no que vier
              apostilado; o que não vier, o laudo indica.
            </p>
            <p>Quando o último documento chegar, a análise começa e o envio fecha. Até lá você pode trocar qualquer arquivo.</p>
          </Intro>
        ) : (
          <>
            <Prazo>
              <CalendarTodayOutlinedIcon />
              <p>
                Laudo previsto para: <strong data-testid="analise-prazo">{prazo || "a confirmar"}</strong>
              </p>
            </Prazo>
            <Trava>
              <strong>
                <LockOutlinedIcon style={{ fontSize: 18, verticalAlign: "text-bottom", marginRight: 6 }} />
                Envio de documentos fechado
              </strong>
              <p>
                Recebemos todos os documentos da lista{analise.iniciada_em ? ` em ${format(parseISO(analise.iniciada_em), "dd/MM/yyyy")}` : ""}. Nossa equipe está
                conferindo cada um; o laudo sai em até {analise.prazo_dias || 7} dias. O que faltar ou estiver em desacordo vai constar do laudo.
              </p>
            </Trava>
          </>
        )}
      </CardStats>

      {documentos.map((doc) => (
        <DocumentoAnalise
          key={doc.document_id || doc.reference_id || doc.name}
          processo={data}
          documento={doc}
          uploadAberto={uploadAberto}
          onProcessoAtualizado={onProcessoAtualizado}
          controllerModal={controllerModal}
          FMDModal={FMDModal}
        />
      ))}
    </>
  );
}
